import axios from 'axios';

// Calendarific API anahtarınızı buraya yazın (ücretsiz almak için: https://calendarific.com/signup)
const CALENDARIFIC_API_KEY = 'F58MLGV91SocY5p8nxMN1RxPQWjVkiWL'; // BURAYI DOLDURMADAN API ÇALIŞMAZ!

/**
 * Calendarific üzerinden Türkiye'nin resmi tatillerini çeker.
 * @param {number|string} year
 * @returns {Promise<Array>} Tatil objeleri
 */
export async function fetchCalendarificHolidays(year) {
  const url = `https://calendarific.com/api/v2/holidays?api_key=${CALENDARIFIC_API_KEY}&country=TR&year=${year}&type=national`;
  try {
    const response = await axios.get(url);
    // Calendarific response: { response: { holidays: [ ... ] } }
    if (response.data && response.data.response && response.data.response.holidays) {
      return response.data.response.holidays;
    }
    return [];
  } catch (error) {
    console.error('Calendarific tatil alınırken hata:', error);
    return [];
  }
}
